import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';

const CompleteTripModal = ({ show, onHide, trip, onConfirm }) => {
    const [notes, setNotes] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        onConfirm(trip.id, notes);
        setNotes(''); // Limpiar para la próxima
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton className="bg-success text-white">
                <Modal.Title>Finalizar Viaje #{trip?.id}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-2">¿Hubo alguna novedad o inconveniente durante el servicio?</p>
                <Form onSubmit={handleSubmit}>
                    <Form.Group>
                        <Form.Label className="small text-muted">Observaciones del Conductor (Opcional)</Form.Label>
                        <Form.Control 
                            as="textarea" 
                            rows={3} 
                            placeholder="Ej: Cliente solicitó espera de 10 min, Desvío por tráfico..." 
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            autoFocus
                        />
                    </Form.Group>
                    <div className="d-flex justify-content-end gap-2 mt-3">
                        <Button variant="secondary" onClick={onHide}>Cancelar</Button>
                        <Button variant="success" type="submit">🏁 Finalizar Servicio</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default CompleteTripModal;